// Ten plik jest generowany automatycznie podczas build procesu
// Nie edytuj go ręcznie - zmiany zostaną nadpisane

export const APP_VERSION = '1.1.0.1';
